import React from "react";
import ASCIIText from "./ASCIIText";
import "./index.css";

export default function App() {
  return (
    <div className="app-root">
      <ASCIIText text="akiba.vip" />
    </div>
  );
}
